"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var StretchContent = function StretchContent(_ref) {
  var children = _ref.children,
      className = _ref.className,
      scrollable = _ref.scrollable,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "className", "scrollable"]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
    className: (0, _classnames.default)("stretch-content", className, {
      "stretch-content--scrollable": scrollable
    })
  }), children);
};

StretchContent.propTypes = {
  scrollable: _propTypes.default.bool
};
var _default = StretchContent;
exports.default = _default;
module.exports = exports["default"];